export const getLastMondayDate = () => {
    const now = new Date()
    const dayOfWeek = now.getDay() // 0 (Sunday) to 6 (Saturday)
    const daysSinceMonday = (dayOfWeek + 6) % 7 // Number of days since last Monday
    const lastMonday = new Date(now.setDate(now.getDate() - daysSinceMonday))
    lastMonday.setHours(0, 0, 0, 0) // Set the time to midnight
    return lastMonday
}
